import { configuration } from "src/environments/environment";

export const Defaults = {
    infoconsent: 14,
    authconsent: 13,
    assessment: 9,
    orRecord: 12,
    operative: 7,
    postSurgical: 11,
    perioperative: 10,
    postFollowup: 15,
    spinalCord: 16,
    vertiflex: 17,
    DocumentLibrary: 27,
    lock_ordernote_OrderNotes: "ORDERNOTES",
    lock_ordernote_CheckedinPayments: "CheckedinPayments",
    lock_ordernote_Checkedindocument: "Checkedindocument",
    lock_ordernote_CheckedinAlert: "CheckedinAlert",
    lock_ordernote_CheckedinContactInfo: "CheckedinContactInfo",
    lock_visitnote_vital: "VITAL",
    lock_visitnote_assesments: "Assessments",
    lock_visitnote_AntiCoagulant: "ANTICOAGULANT",
    lock_visitnote_intake: "INTAKE",
    lock_visitnote_cc: "CC",
    lock_visitnote_hpi: "HPI",
    lock_visitnote_hx: "HX",
    lock_visitnote_ros: "ROS",
    lock_visitnote_allergies: "Allergy",
    lock_visitnote_pe: "PE",
    lock_visitnote_cervical: "Cervical",
    lock_visitnote_lumbar: "Lumbar",
    lock_visitnote_thoracic: "Thoracic",
    lock_visitnote_dx: "DX",
    lock_visitnote_rx: "RX",
    lock_visitnote_orders: "Orders",
    lock_visitnote_procedures: "Procedures",
    lock_visitnote_Discussions: "Discussion",
    lock_visitnote_fuorder: "Follow-Up",
    lock_visitnote_plan: "Plan",
    lock_visitnote_progressNote: "Visit Notes",
    lock_visitnote_pump: "Pump",
    lock_admin_roles: "Roles",
    active: true,
    inActive: false,
    SignOff: true,
    ccAttributeType: "55",
    reasonAttributeType: "38",
    activateAttributeType: "39",
    functionalAttributeType: "40",
    mentalAttributeType: "41",
    safetyAttributeType: "42",
    patTheraphyAttributeType: "43",
    needleSizeAttributeType: "44",
    pumpAccessedAttributeType: "45",
    newMedicationAttributeType: "46",
    pumpCapacityAttributeType: "47",
    bolusAttributeType: "48",
    medicationAttributeType: "49",
    ivSitesAttributeType: "IV Site",
    claimPayerAttributeType: 'ClaimFilingCode',
    insurancePayerAttributeType: 'InsuranceTypeCode',
    claimCodeIdAttributeType: "SecondaryIdentificationType",
    facilityLocationAttributeType: "FacilityTypeCode",

    dressedMasterId: 27,
    rrConditionMasterId: 28,
    hrPositionMasterId: 29,
    hrLocationMasterId: 30,
    hrRegularityMasterId: 31,
    bpLocationMasterId: 32,
    bpPositionMasterId: 33,
    bpMethodMasterId: 34,
    spConditionMasterId: 35,
    spMethodMasterId: 36,
    temperatureMethodMasterId: 37,
    drugAllergiesMasterId: 1,
    foodAllergiesMasterId: 2,
    environmentalAllergiesMasterId: 3,
    reactionsMasterId: 4,
    antiCoagulantsMasterId: 5,
    appStatusMasterId: 6,
    progressStatusMasterId: 50,
    claimMasterId: 54,
    categoryMasterId: 51,
    ascTemplates: 63,
    severity: 64,
    refillRequest: 65,

    vitalsNoteType: "VITALS",
    doctorType: "Doctor",
    nurseType: "Nurse",
    clinictimeduration: -360,

    encNoteType_VisitNoteId: 1,
    encNoteType_ORNoteId: 2,
    encNoteType_OrdernoteId: 3,

    enc_VisitNoteType: 'VisitNotes',
    enc_ORNoteType: 'ORNote',
    enc_OrderNoteType: 'OrderNote',

    appStatus_Confirmed: "Confirmed",
    appStatus_UnConfirmed: "UnConfirmed",
    appStatus_CheckedOut: "Checked Out",
    appStatus_CheckedIn: "Checked In",
    appStatus_Cancelled: "Cancelled",
    appStatus_Completed: "Completed",
    appStatus_ReadytoCoSign: "Ready to CoSign",
    pumpStatus_Active: "1",
    appStatus_Rescheduled: "Rescheduled",
    appStatus_Blocked: "Blocked",
    appStatus_NoShow: "NoShow",
    appStatus_Arrived: "Arrived",
    appStatus_NewRx: "New RX",
    appStatus_RxChange: "RX CHANGE",
    appStatus_RxRefill: "RX REFILL",
    appStatus_Initial: "Initial",
    appStatus_Treatment: "Treatment",
    encStatus_NewVisitNote: "New Visit Note",
    encStatus_InCompleteVisitNote: "InComplete Visit Note",
    encStatus_CompletedVisitNote: "Completed Visit Note",

    encStatus_NewORNote: "New OR Note",
    encStatus_InCompletORNote: "InComplete OR Note",
    encStatus_CompletedORNote: "Completed OR Note",

    encStatus_NewOrderNote: "New Order Note",
    encStatus_InCompletOrderNote: "InComplete Order Note",
    encStatus_CompletedOrderNote: "Completed Order Note",

    allergy_drugType: 1,
    allergy_FoodType: 2,
    allergy_envType: 3,
    allergy_reactionType: 4,
    allergy_antiType: 5,

    claimType_Professional: "Professional",
    claimType_Institutional: "Institutional",

    providerType_Billing: "Billing",
    providerType_Rendering: "RENDERING",


    lock_ornote_consentforms: "consent",
    lock_ornote_assessment: "Assessment",
    lock_ornote_perioprtaive: "Perioperative Orders",
    //lock_ornote_postfollowup: "post followup",
    lock_ornote_postfollowup: "Post Op-Follow-Up",
    lock_ornote_postsurgical: "post surgical",
    lock_ornote_orrecord: "OR Record",
    lock_ornote_operative: "operative",
    lock_ornote_fluoroImage: "fluoro Images",
    // lock_ornote_orAllergies: "or Allergies",
    // lock_ornote_Authconsentforms: "AuthorizationConsent",
    // lock_ornote_Impconsentforms: "ImportantConsent",
    lock_ornote_orAllergies: "OR Allergies",
    lock_ornote_Authconsentforms: "Authorization Consent",
    lock_ornote_Impconsentforms: "Important Instructions",

    // lock_ornote_SpinalCodeconsentforms: "SpinalCodeConsent",
    // lock_ornote_Vertiflexconsentforms: "VertiflexConsent",

    lock_ornote_SpinalCodeconsentforms: "Spinal Cord Consent",
    //lock_ornote_Vertiflexconsentforms: "Vertiflex Consent",
    lock_ornote_Vertiflexconsentforms: "COVID-19 Risk Disclosure",

    lock_demographics_personal: "personal",
    lock_demographics_account: "account",
    lock_demographics_alert: "alert",
    lock_demographics_authorization: "authorization",
    lock_demographics_emergency: "emergency",
    lock_demographics_employment: "employment",
    lock_demographics_forms: "forms",
    lock_demographics_insurance: "insurance",
    lock_demographics_notes: "notes",
    lock_demographics_referral: "referral",
    lock_demographics_pharmacy: "pharmacy",
    lock_demographics_consentforms: "consentforms",
    lock_Rx_PatientSearch: "Rx",

    operative_Sections_PostOperative: "POST OPERATIVE",
    operative_Sections_Disposition: "DISPOSITION AND DISCHARGE",
    message_Type_grant: 18,
    message_Type_finalizeGrant: 19,
    message_Type_revoke: 20,
    message_Type_finalize_revoke: 21,

    //licenseAndInsurenseCatName: "Identification",
    licenseAndInsurenseCatName: 'Patient',
    licenseSubcatName: 'Patient identifications license',
    InsurenseSubcatName: 'Patient identifications',
    // licenseSubcatName: 'LicenseCard',
    // InsurenseSubcatName: 'InsuranceCard',

    fluoroscopeCatName: "FluoroImages",
    fluoroscopeReportCatName: "FluoroReports",
    fluoroscopeSubCatName: "FluoroImages",
    fluoroscopeReportSubCatName: "FluoroReports",

    Appointment_type: 6,

    DocLibraryTargetLocation: 79,
    DocLibraryFieldNames: 74,
    DocLibraryDocCategoryID: 236,
    DocLibraryPatDemographicsID: 91,
    DocLibraryCheckinForm: 94,
    DocLibraryVisitNote: 95,
    DocLibraryORNote: 97,

    EncryptionKey: "78394567263485273854369834359345",
    ProviderRoleName: "Provider",
    isUserRolesApplied: true,

}